import { NgModule, ErrorHandler, Inject  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppAvailability } from '@ionic-native/app-availability/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { DOCUMENT } from '@angular/common';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { DeviceDetectorModule } from 'ngx-device-detector';

import { QuproBaseModule } from '@arpada/arp-lib-common-qupro';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginPageModule } from './pages/login/login.module';
import { UiService, PortalErrorService } from './services/api.services';
import { environment } from '../environments/environment';
import { LanguagesInfo } from '../assets/i18n/languages-info';

let UI_SERVICE: UiService = null;
let PORTAL_ERROR_SERVICE: PortalErrorService = null;

export function onLoginRedirectCallback()  {
  if (UI_SERVICE) {
    UI_SERVICE.onLoginRedirect();
  }
}
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

class ServerErrorHandler implements ErrorHandler {
  handleError(error) {
    console.error(error);
    if (PORTAL_ERROR_SERVICE){
      PORTAL_ERROR_SERVICE.manageError(error);
    }
  }
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    LoginPageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader, // exported factory function needed for AoT compilation
        deps: [HttpClient]
      }
    }),
    DeviceDetectorModule.forRoot(),
    QuproBaseModule.forRoot({
      loginRedirectCallback: onLoginRedirectCallback,
      userResetPassword: environment.userResetPassword,
      passwordUserResetPassword: environment.passwordUserResetPassword,
      apiURL: environment.apiURL,
      apiToken: environment.apiToken,
      apiMaxSessionTime: environment.apiMaxSessionTime,
      apiMaxCachedTime: environment.apiMaxCachedTime,
    }),
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AppAvailability,
    InAppBrowser,
    { provide: ErrorHandler, useClass: ServerErrorHandler}
  ],
  exports: [TranslateModule],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    private translateService: TranslateService,
    private uiService: UiService,
    private portalErrorService: PortalErrorService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    UI_SERVICE = this.uiService;
    LanguagesInfo.initTranslateService(this.translateService, this.document);
    PORTAL_ERROR_SERVICE = this.portalErrorService;
  }
}
